import React, { FC } from "react";
import * as _ from "lodash";

import { Col, Row, Typography } from "@ctra/components";
import { EventContext, GenericEventView, IdaQnAChildEventView, testIds, useEvent } from "@events";

const { Text } = Typography;

/**
 * IdaQnAs Event View component
 * @constructor
 */
export const IdaQnAsEventView: FC<{ open?: boolean }> = (props) => {
  const {
    event: { id, description }
  } = useEvent();

  /**
   * Use the original event description coming from the Ida Classic app without translating
   * @type {string}
   */
  const trimmed = _.trim(description.replace("other:", ""));

  return (
    <GenericEventView {...props}>
      <Row data-testid={testIds.entity.entry.description} gutter={[0, 8]}>
        {!!trimmed && (
          <Col span={24}>
            <Text italic>{trimmed}</Text>
          </Col>
        )}
        <Col span={24}>
          <EventContext.Provider eventID={id}>
            <IdaQnAChildEventView />
          </EventContext.Provider>
        </Col>
      </Row>
    </GenericEventView>
  );
};
